import { bl_fi_budget_fiscal_period_RowClass } from '../../../dbschema/bl_fi_budget_fiscal_period.model';
import { BaseContainerModel } from '../../base-container.model';


export class BudgetFiscalPeriodContainerModel extends BaseContainerModel {
    bl_fi_budget_fiscal_period: bl_fi_budget_fiscal_period_RowClass = new bl_fi_budget_fiscal_period_RowClass();
}
